import $ from 'jquery';


let app = app || {};
let deviceFlg = 'pc';
let _window = $(window);
let changeCurrent = -1;

$(function() {

  //ブラウザの「戻るボタン」で来た時対応
  if($('body').hasClass('page-index')){
    $('body,html').animate({scrollTop: $(window).scrollTop() + 1 }, 1, 'swing');
  }

  let ua = navigator.userAgent;
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
    deviceFlg = 'sp';
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
    $('[name="viewport"]').attr('content','width=1200');
    $('body').addClass('deviceTablet');
    deviceFlg = 'tablet';
    $('.topMovie').append('<source src="assets/mov/index.mp4">');
  } else {
    deviceFlg = 'pc';
    $('.topMovie').append('<source src="assets/mov/index.mp4">');
  }
	_window.on("load resize", function(){
    if($(this).width() <= 768){
      $('body').addClass('tab-sp');
    }else{
      $('body').removeClass('tab-sp');
    }
  });

  
  app.init = function() {
    app.scrollFadeInElms = [];
    app.paginationTarget = [];
    app.pageLink();
    app.ScrollOut();
    $('.js-scroll-action').each(function(index, el) {
      app.scrollFadeInElms.push($(this).offset().top);
    });
    $('[id^="sec"]').each(function(index, el) {
      app.paginationTarget.push($(this).offset().top);
    });

    _window.on("resize", function(){
      app.scrollFadeInElms = [];
      app.paginationTarget = [];
      setTimeout(() => {
        $('.js-scroll-action').each(function(index, el) {
        app.scrollFadeInElms.push($(this).offset().top);
      });
      $('[id^="sec"]').each(function(index, el) {
        app.paginationTarget.push($(this).offset().top);
      });
      }, 1);
    });

	}

	app.sleep = function(ms) {
    return new Promise((resolve,reject) => {
      setTimeout(resolve, ms);
    });
  }

  app.loader = function() {
    // $(window).on('load',function(){
    //   $("#page-loading").delay(1000).fadeOut('slow');
    // });
    setTimeout(function() {
      $("#page-loading").delay(1000).fadeOut('slow');
    }, 1000);


    // function loaderClose(){
    //   $("#page-loading").fadeOut('slow');
    // }
    // setTimeout(loaderClose,10000);
  }


  app.pageLink = function() {
    $('a[href^="#"]').on("click", function(e) {
      let speed = 1000;
      let href= $(this).attr("href");
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top - 70;
      if(href == "#catFukusyoku"){
        speed = 400;
      }
      if(href == "#top" && !$(this).hasClass('is-pageTop')){
        $('body,html').animate({scrollTop:$(window).height()}, speed, 'swing');
      }else{
        $('body,html').animate({scrollTop:position}, speed, 'swing');
      }
      return false;
    });
  }


  app.ScrollOut = function() {
    setTimeout(function() {
      ScrollOut({
        targets: ".catch",
        threshold: 0.2,
        once: true,
      });
      ScrollOut({
        targets: ".anime",
        threshold: 0.2,
        once: true,
      });
    }, 2800);
    
  }


	app.init();

});


// WEBPACK FOOTER //
// ./src/js/internship.js